import { injectable } from 'inversify';
import { LogService } from './LogService';
import { ErrorHandler, Result } from './Result';

interface ErrorText {
  message: string;
  details: string;
}

interface Error {
  error_code: number;
  error_details: ErrorText;
}

interface ErrorEnvelope {
  errors: Error[];
}

@injectable()
export class AxiosErrorHandler implements ErrorHandler {
  private logService: LogService;

  public constructor(logService: LogService) {
    this.logService = logService;
  }

  handleError(error: any) {
    this.logService.logError(error);

    let msg = 'Network error occurred.';
    if (error && error.response && error.response.data) {
      const envelope = error.response.data as ErrorEnvelope;
      if (envelope.errors && Array.isArray(envelope.errors) && envelope.errors.length >= 1) {
        msg = envelope.errors[0].error_details.message;
      }
    }

    const newError: Result<any> = {
      errorMessage: msg,
      isError: true,
    };
    return newError;
  }
}
